import { useCallback, useState } from "react"
import { IconButton, Menu } from "@mui/material"
import { MoreVert } from "@mui/icons-material"
import ItemHeaderMenuItem from "connected-components/compare/components/item-header-menu-item"

export default function CompareFxHedgeMenu({ fxHedgeEnabled, isFxHedgeSupported, onToggle }: CompareFxHedgeMenuProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleToggle = useCallback(() => {
    setAnchorEl(null)
    onToggle(!fxHedgeEnabled)
  }, [fxHedgeEnabled, onToggle])

  return <>
    <IconButton size="small" onClick={(event) => setAnchorEl(event.currentTarget)} data-test-class="comparison-fx-hedge-menu-button">
      <MoreVert fontSize="small" />
    </IconButton>
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={() => setAnchorEl(null)}
    >
      <ItemHeaderMenuItem
        label={fxHedgeEnabled ? "Disable FX Hedge" : "Enable FX Hedge"}
        fn={handleToggle}
        disabled={!fxHedgeEnabled && !isFxHedgeSupported}
        disabledTooltip="FX Hedge is not supported by the current model"
      />
    </Menu>
  </>
}

interface CompareFxHedgeMenuProps {
  fxHedgeEnabled: boolean
  isFxHedgeSupported: boolean
  onToggle: (enabled: boolean) => void
}
